import saveAs from "file-saver";
import htmlDocx from "html-docx-js/dist/html-docx";
import { YearView } from "./FinancialYear";

export const DownloadPerformanceIndex = (count, e) => {
    
    e.preventDefault()
    const content = []
    content.push(`
        <p style="text-align:center; font-weight:bold;">GENERAL INFORMATION</p>
        <table>
        <tr>
            <td>1. Name</td>
            <td>: ${count?.name}</td>
        </tr>
        <tr>
            <td>2. Name of the Department / Centre / Extension Centre</td>
            <td>: ${count?.department}</td>
        </tr>
        <tr>
            <td>3. Current Designation</td>
            <td>: ${count?.designation}</td>
        </tr>
        <tr>
            <td>4. Academic Year</td>
            <td>: ${count?.academic_year > 2023 ? YearView(count?.academic_year) : count?.academic_year}</td>
        </tr>
        </table>
        `)


    content.push(` 
    <h5 style="text-align:center;,margin:10px 0px;">ACADEMIC CONTRIBUTIONS</h5>
    <table style="border-collapse: collapse; width: 100%; border:1px solid black">
        <tr>
            <th style="border:1px solid black;width:30%;text-align:center,">Topic</th>
            <th style="border:1px solid black;width:40%;">Criteria</th>
            <th style="border:1px solid black;width:10%;">Target Fixed</th>
            <th style="border:1px solid black;width:10%;">Score/Item</th>
            <th style="border:1px solid black;width:10%;">Score Fixed</th>
        </tr>
        <tr>
        <td style="border:1px solid black;,padding:12px;">
        <p>a. Grant in aid Training Programmes to be conducted as Coordinator Training programmes conducted for 3 days as 0.5 equivalence and "n" weeks as "n" equivalence of 5 days Conduct of number of 5 days training programmes 20, 18 and 16 for Assistant Professor, Associate Professor and Professor respectively.  Revenue Generated through Training Programmes as Co-ordinator</p>
        </td>
        <td style="border:1px solid black;">
                <p style="">
                Training Programmes conducted as Coordinator
                </p>
                <p style="">
                Additional training programmes conducted as
                Coordinator
                </p>
                <p style="">
                &lt; 3 lakhs
                </p>
                <p style="">
                3-5 lakhs
                </p>
                <p style="">
                &gt; 5 lakhs
                </p>
         </td>
         <td style="border:1px solid black;">
            <p style="padding-bottom:20px;">
            ${count?.academic_contributions?.non_sponsored_training?.total_activity || '-'}
            </p>
            <p style="padding-bottom:20px;">
            ${count?.academic_contributions?.training_programmes_conducted?.total_activity || '-'}
            </p>
            <p  style="">
            ${count?.academic_contributions?.aid_training_programmes_lt_3_lakhs?.total_activity || '-'}
            </p>
            <p  style="">
            ${count?.academic_contributions?.aid_training_programmes_3_t0_5_lakhs?.total_activity || '-'}
            </p>
            <p  style="">
            ${count?.academic_contributions?.aid_training_programmes_gt_5_lakhs?.total_activity || '-'}
            </p>
        </td>
        <td style="border:1px solid black;">
        <p  style="">
        ${count?.academic_contributions?.non_sponsored_training?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions?.training_programmes_conducted?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions?.aid_training_programmes_lt_3_lakhs?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions?.aid_training_programmes_3_t0_5_lakhs?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions?.aid_training_programmes_gt_5_lakhs?.per_actitity_score || '-'}
        </p>
        </td>

        <td style="border:1px solid black;">
        <p  style="">
        ${count?.academic_contributions
            ?.non_sponsored_training?.total_activity *
        count?.academic_contributions
            ?.non_sponsored_training?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions
            ?.training_programmes_conducted?.total_activity *
        count?.academic_contributions
            ?.training_programmes_conducted?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions
            ?.aid_training_programmes_lt_3_lakhs?.total_activity *
        count?.academic_contributions
            ?.aid_training_programmes_lt_3_lakhs?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions
            ?.aid_training_programmes_3_t0_5_lakhs?.total_activity *
        count?.academic_contributions
            ?.aid_training_programmes_3_t0_5_lakhs?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions
            ?.aid_training_programmes_gt_5_lakhs?.total_activity *
        count?.academic_contributions
            ?.aid_training_programmes_gt_5_lakhs?.per_actitity_score || '-'}
        </p>
        </td>
        </tr>



        <tr>
        <td style="border:1px solid black;,padding:12px;"><p>b. Sponsored Training Programmes conducted as Coordinator/ Co-coordinator (Funded by State/ Central Government or ITEC)</p>
        </td>
        <td style="border:1px solid black;">
                <p style="">
                Training programmes conducted as Coordinator
                </p>
                <p style="">
                Training programmes conducted as Co-coordinator
                </p>
         </td>
         <td style="border:1px solid black;">
            <p style="padding-bottom:20px;">
            ${count?.academic_contributions?.sponsored_contact_mode_for_coordinator_training?.total_activity || '-'}
            </p>
            <p style="padding-bottom:20px;">
            ${count?.academic_contributions?.sponsored_contact_mode_for_co_coordinator_training?.total_activity || '-'}
            </p>
         </td>
        <td style="border:1px solid black;">
        <p  style="">
        ${count?.academic_contributions?.sponsored_contact_mode_for_coordinator_training?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions?.sponsored_contact_mode_for_co_coordinator_training?.per_actitity_score || '-'}
        </p>
       </td>

        <td style="border:1px solid black;">
        <p  style="">
        ${count?.academic_contributions
            ?.sponsored_contact_mode_for_coordinator_training?.total_activity *
        count?.academic_contributions
            ?.sponsored_contact_mode_for_coordinator_training?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions
            ?.sponsored_contact_mode_for_co_coordinator_training?.total_activity *
        count?.academic_contributions
            ?.sponsored_contact_mode_for_co_coordinator_training?.per_actitity_score || '-'}
        </p>
        </td>
        </tr>    



        <tr>
        <td style="border:1px solid black;,padding:12px;"><p>c. Skill Development/ Industrial Training Programmes conducted as Coordinator/ Co-coordinator</p>
        </td>
        <td style="border:1px solid black;">
                <p style="">
                Training programmes conducted as Coordinator
                </p>
                <p style="">
                Training programmes conducted as Co-coordinator
                </p>
         </td>
         <td style="border:1px solid black;">
            <p style="padding-bottom:20px;">
            ${count?.academic_contributions?.skill_development_for_coordinator_training?.total_activity || '-'}
            </p>
            <p style="padding-bottom:20px;">
            ${count?.academic_contributions?.skill_development_for_co_coordinator_training?.total_activity || '-'}
            </p>
         </td>
        <td style="border:1px solid black;">
        <p  style="">
        ${count?.academic_contributions?.skill_development_for_coordinator_training?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions?.skill_development_for_co_coordinator_training?.per_actitity_score || '-'}
        </p>
       </td>

        <td style="border:1px solid black;">
        <p  style="">
        ${count?.academic_contributions
            ?.skill_development_for_coordinator_training?.total_activity *
        count?.academic_contributions
            ?.skill_development_for_coordinator_training?.per_actitity_score || '-'}
        </p>
        <p  style="">
        ${count?.academic_contributions
            ?.skill_development_for_co_coordinator_training?.total_activity *
        count?.academic_contributions
            ?.skill_development_for_co_coordinator_training?.per_actitity_score || '-'}
        </p>
        </td>
        </tr>    

        <tr>
        <td style="border:1px solid black;">
           <p> d. Development/ offer of MOOCs/ MMLPs as Coordinator/
            Co-coordinator or minimum 30 min video lectures/
            Educational video films</p>
        </td>
        <td style="border:1px solid black;">
           <p>
                Offering of SWAYAM Course/ NITTT module
            </p>
            
            <p>
                    Development of minimum 30 min video lecture/
                    Educational video films
            </p>
        </td>
        <td style="border:1px solid black;">
            <p>
             
                    ${count?.academic_contributions
            ?.development_of_moocs_offering_swayam_courses_or_nittt_module?.total_activity || '-'
        }
                
            </p>
            
                <p>
                    ${count?.academic_contributions
            ?.development_for_minimum_30_min_video?.total_activity || '-'
        }
                </p>
        </td>
        <td style="border:1px solid black;">
            <p>
                    ${count?.academic_contributions
            ?.development_of_moocs_offering_swayam_courses_or_nittt_module?.per_actitity_score || '-'
        }
            </p>
            
            <p>
                    ${count?.academic_contributions
            ?.development_for_minimum_30_min_video?.per_actitity_score || '-'
        }
            </p>
        </td>
        <td style="border:1px solid black;">
            <p>
                    ${count?.academic_contributions
            ?.development_of_moocs_offering_swayam_courses_or_nittt_module?.total_activity *
        count?.academic_contributions
            ?.development_of_moocs_offering_swayam_courses_or_nittt_module?.per_actitity_score || '-'}
            </p>
            
               <p>
                    ${count?.academic_contributions
            ?.development_for_minimum_30_min_video?.total_activity *
        count?.academic_contributions
            ?.development_for_minimum_30_min_video?.per_actitity_score || '-'}
                </p>
        </td>
          </tr>              


        <tr>                
        <td style="border:1px solid black;">
       <p> e. Resource person in Training Programmes (Institute)	</p>
        </td>
        <td style="border:1px solid black;">
           <p>
           For 18 hours	
            </p>
        </td>
        <td style="border:1px solid black;">
            <p>
             
                    ${count?.academic_contributions
            ?.resouce_program_in_training_programmes?.total_activity || '-'
        }
                
            </p>
                  </td>
        <td style="border:1px solid black;">
            <p>
                    ${count?.academic_contributions
            ?.resouce_program_in_training_programmes?.per_actitity_score || '-'
        }
            </p>
                 </td>
        <td style="border:1px solid black;">
            <p>
                    ${count?.academic_contributions
            ?.resouce_program_in_training_programmes?.total_activity *
        count?.academic_contributions
            ?.resouce_program_in_training_programmes?.per_actitity_score || '-'}
            </p>
        </td>
        </tr>


        <tr>
        <td style="border:1px solid black;">
        <p>
        f. Development of Training/ Laboratory Manuals</p>
    </td>
    <td style="border:1px solid black;">
       <p>
       Development of Training/ Laboratory Manuals
        </p>
    </td>
    <td style="border:1px solid black;">
        <p>
         
                ${count?.academic_contributions
            ?.development_of_training_manual?.total_activity || '-'
        }
            
        </p>

    </td>
    <td style="border:1px solid black;">
        <p>
                ${count?.academic_contributions
            ?.development_of_training_manual?.per_actitity_score || '-'
        }
        </p>
        
    </td>
    <td style="border:1px solid black;">
        <p>
                ${count?.academic_contributions
            ?.development_of_training_manual?.total_activity *
        count?.academic_contributions
            ?.development_of_training_manual?.per_actitity_score || '-'}
        </p>
    </td>
    </tr>


    <tr>
    <td style="border:1px solid black;">
   <p> g. Courses handled for PG/ Ph.D. programme</p>
    </td>
    <td style="border:1px solid black;">
       <p>
       Classes handled individually for a 3 credit course/ semester
        (If classes were conducted jointly, then the score will
        be considered proportionately based on the number of faculty members involved)

        </p>
    </td>
    <td style="border:1px solid black;">
        <p>
         
                ${count?.academic_contributions
            ?.coursed_handled_for_pg_phd_programme?.total_activity || '-'
        }
            
        </p>

    </td>
    <td style="border:1px solid black;">
        <p>
                ${count?.academic_contributions
            ?.coursed_handled_for_pg_phd_programme?.per_actitity_score || '-'
        }
        </p>
        
    </td>
    <td style="border:1px solid black;">
        <p>
                ${count?.academic_contributions
            ?.coursed_handled_for_pg_phd_programme?.total_activity *
        count?.academic_contributions
            ?.coursed_handled_for_pg_phd_programme?.per_actitity_score || '-'}
        </p>

    </td>
    </tr>

    <tr>
    <td style="border:1px solid black;">
    <p>h. New course(s) developed and offered</p>
    </td>
    <td style="border:1px solid black;">
       <p>
       3 credit course or its equivalent
        </p>
    </td>
    <td style="border:1px solid black;">
        <p>
         
                ${count?.academic_contributions
            ?.new_courses_developed_and_offered?.total_activity || '-'
        }
            
        </p>

    </td>
    <td style="border:1px solid black;">
        <p>
                ${count?.academic_contributions
            ?.new_courses_developed_and_offered?.per_actitity_score || '-'
        }
        </p>
        
    </td>
    <td style="border:1px solid black;">
        <p>
                ${count?.academic_contributions
            ?.new_courses_developed_and_offered?.total_activity *
        count?.academic_contributions
            ?.new_courses_developed_and_offered?.per_actitity_score || '-'}
        </p>

    </td>
    </tr> 

    <tr>
    <td style="border:1px solid black;">
   <p> i. Curriculum Developed/ Revised</p>
    </td>
    <td style="border:1px solid black;">
       <p>
       &lt; 3 lakhs
        </p>
        <p>
        3 - 5 lakhs
        </p>
        <p>
        5 - 10 lakhs
        </p>
        <p>
        10 - 15 lakhs
        </p>
        <p>
        &gt; 15 lakhs
        </p>
    </td>
    <td style="border:1px solid black;">
        <p>
         
                ${count?.academic_contributions
            ?.curriculum_developed_revised_lt_3_lakhs?.total_activity || '-'
        }
            
        </p>
        <p>
         
        ${count?.academic_contributions
            ?.curriculum_developed_revised_3_to_5_lakhs?.total_activity || '-'
        }
    
</p>
<p>
         
${count?.academic_contributions
            ?.curriculum_developed_revised_5_to_10_lakhs?.total_activity || '-'
        }

</p>
<p>
         
${count?.academic_contributions
            ?.curriculum_developed_revised_10_to_15_lakhs?.total_activity || '-'
        }

</p>
<p>
         
${count?.academic_contributions
            ?.curriculum_developed_revised_gt_15_lakhs?.total_activity || '-'
        }

</p>

    </td>
    <td style="border:1px solid black;">
        <p>
        ${count?.academic_contributions?.curriculum_developed_revised_lt_3_lakhs?.per_actitity_score || '-'}
        </p>
        <p>
            ${count?.academic_contributions
            ?.curriculum_developed_revised_3_to_5_lakhs?.per_actitity_score || '-'
        }
        </p>
        <p>
        ${count?.academic_contributions
            ?.curriculum_developed_revised_5_to_10_lakhs?.per_actitity_score || '-'
        }
        </p>
        <p>
            ${count?.academic_contributions
            ?.curriculum_developed_revised_10_to_15_lakhs?.per_actitity_score || '-'
        }
        </p>
        <p>
            ${count?.academic_contributions
            ?.curriculum_developed_revised_gt_15_lakhs?.per_actitity_score || '-'
        }
        </p>
        
    </td>
    <td style="border:1px solid black;">
        <p>
                ${count?.academic_contributions
            ?.curriculum_developed_revised_lt_3_lakhs?.total_activity *
        count?.academic_contributions
            ?.curriculum_developed_revised_lt_3_lakhs?.per_actitity_score || '-'}
        </p>
        <P>
        ${count?.academic_contributions
            ?.curriculum_developed_revised_3_to_5_lakhs?.total_activity *
        count?.academic_contributions
            ?.curriculum_developed_revised_3_to_5_lakhs?.per_actitity_score || '-'}
        </p>
        <p>
            ${count?.academic_contributions
            ?.curriculum_developed_revised_5_to_10_lakhs?.total_activity *
        count?.academic_contributions
            ?.curriculum_developed_revised_5_to_10_lakhs?.per_actitity_score || '-'}
        </p>
        <p>
                ${count?.academic_contributions
            ?.curriculum_developed_revised_10_to_15_lakhs?.total_activity *
        count?.academic_contributions
            ?.curriculum_developed_revised_10_to_15_lakhs?.per_actitity_score || '-'}
        </p>
        <p>
                    ${count?.academic_contributions
            ?.curriculum_developed_revised_gt_15_lakhs?.total_activity *
        count?.academic_contributions
            ?.curriculum_developed_revised_gt_15_lakhs?.per_actitity_score || '-'}
        </p>

    </td>
    </tr>
                        <tr>
                            <td><p> Total</p></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>${count?.academic_contributions_total_score_fixed}</td >
                        </tr >


    </table >
    `)

    content.push(`
    <h5 style = "text-align:center;,margin:10px 0px;" > RESEARCH CONTRIBUTIONS</h5>
        <table style="border-collapse: collapse; width: 100%; border:1px solid black">
            <tr>
                <th style="border:1px solid black;width:30%;text-align:center,">Topic</th>
                <th style="border:1px solid black;width:40%;">Criteria</th>
                <th style="border:1px solid black;width:10%;">Target Fixed</th>
                <th style="border:1px solid black;width:10%;">Score/Item</th>
                <th style="border:1px solid black;width:10%;">Score Fixed</th>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p>a. Ph.D. research scholars guided</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        Degree awarded
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>${count?.research_contributions
            ?.phd_research_guidance?.total_activity || '-'
        }

                    </p>

                </td>
                <td style="border:1px solid black;">
                    <p>
                        ${count?.research_contributions
            ?.phd_research_guidance?.per_actitity_score || '-'
        }
                    </p>

                </td>
                <td style="border:1px solid black;">
                    <p>
                        ${count?.research_contributions
            ?.phd_research_guidance?.total_activity *
        count?.research_contributions
            ?.phd_research_guidance?.per_actitity_score || '-'}
                    </p>
                </td>
            </tr>


            <tr>
                <td style="border:1px solid black;">
                    <p> b. Post Graduate thesis guided</p>
                </td>
                <td style="border:1px solid black;">Degree awarded</td>
                <td style="border:1px solid black;">
                    ${count?.research_contributions
            ?.post_graduate_thesis_guidance?.total_activity || '-'
        }
                </td>
                <td style="border:1px solid black;">
                    ${count?.research_contributions
            ?.post_graduate_thesis_guidance?.per_actitity_score || '-'
        }
                </td>
                <td style="border:1px solid black;">
                    ${count?.research_contributions
            ?.post_graduate_thesis_guidance?.total_activity *
        count?.research_contributions
            ?.post_graduate_thesis_guidance?.per_actitity_score || '-'}
                </td>
            </tr>


            <tr>
                <td style="border:1px solid black;">
                    <p>c. Sponsored research projects carried out</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        Submitted
                    </p>

                    <p>
                        &lt; 5 lakhs
                    </p>

                    <p>
                        5 - 15 lakhs
                    </p>

                    <p>
                        &gt; 15 lakhs
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_submitted?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_lt_5_lakhs?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_5_to_15_lakhs?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_gt_15_lakhs?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_submitted?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_lt_5_lakhs?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_5_to_15_lakhs?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_gt_15_lakhs?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_submitted?.total_activity *
        count?.research_contributions
            ?.sponsored_research_projects_submitted?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_lt_5_lakhs?.total_activity *
        count?.research_contributions
            ?.sponsored_research_projects_lt_5_lakhs?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_5_to_15_lakhs?.total_activity *
        count?.research_contributions
            ?.sponsored_research_projects_5_to_15_lakhs?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.sponsored_research_projects_gt_15_lakhs?.total_activity *
        count?.research_contributions
            ?.sponsored_research_projects_gt_15_lakhs?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>

            <tr>
                <td style="border:1px solid black;">
                    <p> d. Consultancy works carried out based on the requirements of the Clientele system.</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        &lt; 3 lakhs
                    </p>

                    <p>
                        3 - 5 lakhs
                    </p>

                    <p>
                        &gt; 5 lakhs
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.consultancy_works_carried_out_lt_3_lakhs?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.consultancy_works_carried_out_3_to_5_lakhs?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.consultancy_works_carried_out_gt_5_lakhs?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.consultancy_works_carried_out_lt_3_lakhs?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.consultancy_works_carried_out_3_to_5_lakhs?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.consultancy_works_carried_out_gt_5_lakhs?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.consultancy_works_carried_out_lt_3_lakhs?.total_activity *
        count?.research_contributions
            ?.consultancy_works_carried_out_lt_3_lakhs?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.consultancy_works_carried_out_3_to_5_lakhs?.total_activity *
        count?.research_contributions
            ?.consultancy_works_carried_out_3_to_5_lakhs?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.consultancy_works_carried_out_gt_5_lakhs?.total_activity *
        count?.research_contributions
            ?.consultancy_works_carried_out_gt_5_lakhs?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>

            <tr>
                <td style="border:1px solid black;">
                    <p> e. Research publications in referred
journals only as first/ corresponding
author (For more than one author, the
score for other authors will be 50%)</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        SCI
                    </p>

                    <p>
                        Scopus indexed
                    </p>

                    <p>
                        UGC listed
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.research_publications_in_sci?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.research_publications_in_scopus_indexed?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.research_publications_in_ugc_listed?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.research_publications_in_sci?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.research_publications_in_scopus_indexed?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.research_publications_in_ugc_listed?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.research_publications_in_sci?.total_activity *
        count?.research_contributions
            ?.research_publications_in_sci?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.research_publications_in_scopus_indexed?.total_activity *
        count?.research_contributions
            ?.research_publications_in_scopus_indexed?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.research_publications_in_ugc_listed?.total_activity *
        count?.research_contributions
            ?.research_publications_in_ugc_listed?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p> f. Papers presented in national/ international
                        conference/ seminar</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        International
                    </p>

                    <p>
                        National
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.paper_presented_in_international?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.paper_presented_in_national?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.paper_presented_in_international?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.paper_presented_in_national?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.paper_presented_in_international?.total_activity *
        count?.research_contributions
            ?.paper_presented_in_international?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.paper_presented_in_national?.total_activity *
        count?.research_contributions
            ?.paper_presented_in_national?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p>g. Books Authored/ Edited book/ edited
                        proceedings/ book chapter/ monographs (only with
                        ISBN/ ISSN) (as first author, for more than one author, the score for other authors will be 50%)</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        Books - International Publisher
                    </p>

                    <p>
                        Books - National Publisher
                    </p>

                    <p>
                        Book Chapter - International Publisher
                    </p>

                    <p>
                        Book Chapter - National Publisher
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.books_international_publisher?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.books_national_publisher?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.book_chapter_international_publisher?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.book_chapter_national_publisher?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.books_international_publisher?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.books_national_publisher?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.book_chapter_international_publisher?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.book_chapter_national_publisher?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.books_international_publisher?.total_activity *
        count?.research_contributions
            ?.books_international_publisher?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.books_national_publisher?.total_activity *
        count?.research_contributions
            ?.books_national_publisher?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.book_chapter_international_publisher?.total_activity *
        count?.research_contributions
            ?.book_chapter_international_publisher?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.book_chapter_national_publisher?.total_activity *
        count?.research_contributions
            ?.book_chapter_national_publisher?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p>h. Patents, copy right and technology transfer
                        agreements signed</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        Granted - International
                    </p>

                    <p>
                        Granted - National
                    </p>

                    <p>
                        Published - International
                    </p>

                    <p>
                        Published - National
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.patents_granted_international?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions?.patents_granted?.total_activity || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions?.patents_filed_international?.total_activity || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions?.patents_filed?.total_activity || '-'}

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.patents_granted_international?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions?.patents_granted?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions?.patents_filed_international?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions?.patents_filed?.per_actitity_score || '-'}

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.patents_granted_international?.total_activity *
        count?.research_contributions
            ?.patents_granted_international?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.patents_granted?.total_activity *
        count?.research_contributions
            ?.patents_granted?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.patents_filed_international?.total_activity *
        count?.research_contributions
            ?.patents_filed_international?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.patents_filed?.total_activity *
        count?.research_contributions
            ?.patents_filed?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p>i. Honors/ awards/ medals/ fellowships for
                        outstanding contributions</P>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        International
                    </p>

                    <p>
                        National
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.international_awards?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.national_awards?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.international_awards?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.national_awards?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.research_contributions
            ?.international_awards?.total_activity *
        count?.research_contributions
            ?.international_awards?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.research_contributions
            ?.national_awards?.total_activity *
        count?.research_contributions
            ?.national_awards?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
            <td><p> Total</p></td>
            <td></td>
            <td></td>
            <td></td>
            <td>${count?.research_contributions_total_score_fixed}</td >
        </tr >
        </table>`)


    content.push(`
            <h5 style = "text-align:center;,margin:10px 0px;" > INSTITUTIONAL DEVELOPMENT</h5>
                <table style="border-collapse: collapse; width: 100%; border:1px solid black">
                    <tr>
                        <th style="border:1px solid black;width:30%;text-align:center,">Topic</th>
                        <th style="border:1px solid black;width:40%;">Criteria</th>
                        <th style="border:1px solid black;width:10%;">Target Fixed</th>
                        <th style="border:1px solid black;width:10%;">Score/Item</th>
                        <th style="border:1px solid black;width:10%;">Score Fixed</th>
                    </tr>

                    <tr>
                        <td style="border:1px solid black;">
                            <p> a. Administrative contributions (subject to the
                                conduct of atleast two meetings in 6 months) </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                HOD/ In charge/ Chairman of the Committee

                            </p>

                            <p>
                                Member of Committee
                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.administrative_contributions_hod_of_the_committee?.total_activity || '-'
        }

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.administrative_contributions_member_of_the_committee?.total_activity || '-'
        }

                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.administrative_contributions_hod_of_the_committee?.per_actitity_score || '-'
        }

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.administrative_contributions_member_of_the_committee?.per_actitity_score || '-'
        }

                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.administrative_contributions_hod_of_the_committee?.total_activity *
        count?.institutional_development
            ?.administrative_contributions_hod_of_the_committee?.per_actitity_score || '-'}

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.administrative_contributions_member_of_the_committee?.total_activity *
        count?.institutional_development
            ?.administrative_contributions_member_of_the_committee?.per_actitity_score || '-'}

                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style="border:1px solid black;">
                            <p>b. Infrastructure developed with internal/
                                external funding for improvement in science and
                                technology</p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>
                                Internal Funding more than 10 lakhs
                            </p>

                            <p>
                                External Funding upto 5 lakhs
                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.infrastructure_development_internal_funding_upto_10_lakhs?.total_activity || '-'
        }

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.infrastructure_development_external_funding_upto_5_lakhs?.total_activity || '-'
        }

                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.infrastructure_development_internal_funding_upto_10_lakhs?.per_actitity_score || '-'
        }

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.infrastructure_development_external_funding_upto_5_lakhs?.per_actitity_score || '-'
        }

                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.infrastructure_development_internal_funding_upto_10_lakhs?.total_activity *
        count?.institutional_development
            ?.infrastructure_development_internal_funding_upto_10_lakhs?.per_actitity_score || '-'}

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.infrastructure_development_external_funding_upto_5_lakhs?.total_activity *
        count?.institutional_development
            ?.infrastructure_development_external_funding_upto_5_lakhs?.per_actitity_score || '-'}

                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style="border:1px solid black;">
                            <p>c. Research/ academic events (workshop/
                                conference/ seminar/ webinar/ programmes under
                                national initiatives) organized at national/
                                international level as Coordinator (Score for the
                                webinar will be 20% of workshop/ conference/
                                seminar; Score for the Co-coordinator of workshop/
                                conference/ seminar will be 50%)
                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                International/ Programmes under national
                                initiatives

                            </p>

                            <p>
                                National
                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.research_or_academic_events_international?.total_activity || '-'
        }

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.research_or_academic_events_national?.total_activity || '-'
        }

                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.research_or_academic_events_international?.per_actitity_score || '-'
        }

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.research_or_academic_events_national?.per_actitity_score || '-'
        }

                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.research_or_academic_events_international?.total_activity *
        count?.institutional_development
            ?.research_or_academic_events_international?.per_actitity_score || '-'}

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.research_or_academic_events_national?.total_activity *
        count?.institutional_development
            ?.research_or_academic_events_national?.per_actitity_score || '-'}

                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style="border:1px solid black;">
                            <p> d. Events conducted in collaboration with Industry<p />
                        </td>
                        <td style="border:1px solid black;">
                            <p>
                                With Revenue Generation
                            </p>

                            <p>
                                Without Revenue Generation
                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.events_conducted_with_revenue_generation?.total_activity || '-'
        }

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.events_conducted_without_revenue_generation?.total_activity || '-'
        }

                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.events_conducted_with_revenue_generation?.per_actitity_score || '-'
        }

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.events_conducted_without_revenue_generation?.per_actitity_score || '-'
        }

                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.events_conducted_with_revenue_generation?.total_activity *
        count?.institutional_development
            ?.events_conducted_with_revenue_generation?.per_actitity_score || '-'}

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.events_conducted_without_revenue_generation?.total_activity *
        count?.institutional_development
            ?.events_conducted_without_revenue_generation?.per_actitity_score || '-'}

                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style="border:1px solid black;">
                            <p> e. New initiatives implemented for the Institute
                                Development:</p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>
                                With Revenue Generation
                            </p>

                            <p>
                                Without Revenue Generation
                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.new_initiatives_implemented_with_revenue_generation?.total_activity || '-'
        }

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.new_initiatives_implemented_without_revenue_generation?.total_activity || '-'
        }

                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.new_initiatives_implemented_with_revenue_generation?.per_actitity_score || '-'
        }

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.new_initiatives_implemented_without_revenue_generation?.per_actitity_score || '-'
        }

                            </p>
                        </td>
                        <td style="border:1px solid black;">
                            <p>

                                ${count?.institutional_development
            ?.new_initiatives_implemented_with_revenue_generation?.total_activity *
        count?.institutional_development
            ?.new_initiatives_implemented_with_revenue_generation?.per_actitity_score || '-'}

                            </p>

                            <p>

                                ${count?.institutional_development
            ?.new_initiatives_implemented_without_revenue_generation?.total_activity *
        count?.institutional_development
            ?.new_initiatives_implemented_without_revenue_generation?.per_actitity_score || '-'}

                            </p>
                        </td>
                    </tr>
                    <tr>
                    <td><p> Total</p></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>${count?.institutional_development_total_score_fixed}</td >
                </tr >
                </table>
`)

    content.push(`
    <h5 style = "text-align:center;,margin:10px 0px;" > PROFESSIONAL CONTRIBUTIONS</h5>
        <table style="border-collapse: collapse; width: 100%; border:1px solid black">
            <tr>
                <th style="border:1px solid black;width:30%;text-align:center,">Topic</th>
                <th style="border:1px solid black;width:40%;">Criteria</th>
                <th style="border:1px solid black;width:10%;">Target Fixed</th>
                <th style="border:1px solid black;width:10%;">Score/Item</th>
                <th style="border:1px solid black;width:10%;">Score Fixed</th>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p>   a. Resource person in Training Programmes/
                        Workshops (External)<p />
                </td>
                <td style="border:1px solid black;">
                    <p>
                        For 12 hours
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.resource_person_in_training_programmes?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.resource_person_in_training_programmes?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.resource_person_in_training_programmes?.total_activity *
        count?.professional_contributions
            ?.resource_person_in_training_programmes?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p> b. Training programmes attended</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        International
                    </p>

                    <p>
                        National
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.training_programmes_attended_international?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.training_programmes_attended_national?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.training_programmes_attended_international?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.training_programmes_attended_national?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.training_programmes_attended_international?.total_activity *
        count?.professional_contributions
            ?.training_programmes_attended_international?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.training_programmes_attended_national?.total_activity *
        count?.professional_contributions
            ?.training_programmes_attended_national?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p> c. Participation and academic contributions in the
                        area of your academic and professional expertise
                        at International/ National/ State Level</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        International
                    </p>

                    <p>
                        National
                    </p>

                    <p>
                        State
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.participation_and_academic_contributions_international?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_academic_contributions_national?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_academic_contributions_state?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.participation_and_academic_contributions_international?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_academic_contributions_national?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_academic_contributions_state?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.participation_and_academic_contributions_international?.total_activity *
        count?.professional_contributions
            ?.participation_and_academic_contributions_international?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_academic_contributions_national?.total_activity *
        count?.professional_contributions
            ?.participation_and_academic_contributions_national?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_academic_contributions_state?.total_activity *
        count?.professional_contributions
            ?.participation_and_academic_contributions_state?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p> d. Overseas visited for Academic Events/ Plenary
                        Lectures/ Invited Talks/ Part of Delegation/
                        Others</p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        academic events/ plenary lectures/ invited
                        talks/

                    </p>

                    <p>
                        Part of delegation
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.overseas_visited_for_academic_events?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.overseas_visited_for_part_of_delegation?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.overseas_visited_for_academic_events?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.overseas_visited_for_part_of_delegation?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.overseas_visited_for_academic_events?.total_activity *
        count?.professional_contributions
            ?.overseas_visited_for_academic_events?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.overseas_visited_for_part_of_delegation?.total_activity *
        count?.professional_contributions
            ?.overseas_visited_for_part_of_delegation?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p>  e. Participation and contributions in the area of
                        your academic and professional expertise</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        PG Examiner
                    </p>

                    <p>
                        Doctoral Committee member
                    </p>

                    <p>
                        Ph.D. Examiner
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.participation_and_contributions_in_pg_examiner?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_contributions_in_doctoral_committee?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_contributions_in_phd_examiner?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.participation_and_contributions_in_pg_examiner?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_contributions_in_doctoral_committee?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_contributions_in_phd_examiner?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.participation_and_contributions_in_pg_examiner?.total_activity *
        count?.professional_contributions
            ?.participation_and_contributions_in_pg_examiner?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_contributions_in_doctoral_committee?.total_activity *
        count?.professional_contributions
            ?.participation_and_contributions_in_doctoral_committee?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.participation_and_contributions_in_phd_examiner?.total_activity *
        count?.professional_contributions
            ?.participation_and_contributions_in_phd_examiner?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p> f. Editor-in-Chief/ Editorial Board Member/ Peer
                        Reviewer/ Others</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        Editor-in-chief (SCI)
                    </p>

                    <p>
                        Editor-in-chief (Scopus)
                    </p>

                    <p>
                        Editorial board member (SCI)
                    </p>

                    <p>
                        Editorial board member (Scopus)
                    </p>

                    <p>
                        Peer reviewer (SCI)
                    </p>

                    <p>
                        Peer reviewer (Scopus)
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.editor_in_cheif_sci?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.editor_in_cheif_scopus?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.editorial_board_member_sci?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.editorial_board_member_scopus?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.peer_reviewer_sci?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.peer_reviewer_scopus?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.editor_in_cheif_sci?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.editor_in_cheif_scopus?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.editorial_board_member_sci?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.editorial_board_member_scopus?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.peer_reviewer_sci?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.peer_reviewer_scopus?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.editor_in_cheif_sci?.total_activity *
        count?.professional_contributions
            ?.editor_in_cheif_sci?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.editor_in_cheif_scopus?.total_activity *
        count?.professional_contributions
            ?.editor_in_cheif_scopus?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.editorial_board_member_sci?.total_activity *
        count?.professional_contributions
            ?.editorial_board_member_sci?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.editorial_board_member_scopus?.total_activity *
        count?.professional_contributions
            ?.editorial_board_member_scopus?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.peer_reviewer_sci?.total_activity *
        count?.professional_contributions
            ?.peer_reviewer_sci?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.peer_reviewer_scopus?.total_activity *
        count?.professional_contributions
            ?.peer_reviewer_scopus?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <p>  g. National/ International academic assignment for
                        more than 1 year (Full-time)</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        International
                    </p>

                    <p>
                        National
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.international_academic_assignment?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.national_academic_assignment?.total_activity || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.international_academic_assignment?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.national_academic_assignment?.per_actitity_score || '-'
        }

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions
            ?.international_academic_assignment?.total_activity *
        count?.professional_contributions
            ?.international_academic_assignment?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.national_academic_assignment?.total_activity *
        count?.professional_contributions
            ?.national_academic_assignment?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
                <td style="border:1px solid black;">
                    <P>h. Fellow/ Life Member/ Member of Professional
                        Bodies/ Societies</p>
                </td>
                <td style="border:1px solid black;">
                    <p>
                        Fellow
                    </p>

                    <p>
                        Life member
                    </p>

                    <p>
                        Member
                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions?.fellow?.total_activity || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.life_member?.total_activity || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions?.member?.total_activity || '-'}

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions?.fellow?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.life_member?.per_actitity_score || '-'
        }

                    </p>

                    <p>

                        ${count?.professional_contributions?.member?.per_actitity_score || '-'}

                    </p>
                </td>
                <td style="border:1px solid black;">
                    <p>

                        ${count?.professional_contributions?.fellow?.total_activity *
        count?.professional_contributions?.fellow?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions
            ?.life_member?.total_activity *
        count?.professional_contributions
            ?.life_member?.per_actitity_score || '-'}

                    </p>

                    <p>

                        ${count?.professional_contributions?.member?.total_activity *
        count?.professional_contributions?.member?.per_actitity_score || '-'}

                    </p>
                </td>
            </tr>
            <tr>
            <td><p> Total</p></td>
            <td></td>
            <td></td>
            <td></td>
            <td>${count?.professional_contributions_total_score_fixed}</td >
        </tr >
        </table>

`)


    const htmlContent = content.join("");

    const blob = htmlDocx.asBlob(htmlContent);
    saveAs(blob, "Performance Fixed Score Report.docx");
}